export default class BlockContact {
    constructor(container, options) {
        const defaultOptions = {
            venueSelect: '.select-venue .venues .venue',
            contactBlock: '.contacts-block',
        };
        this.options = Object.assign({}, defaultOptions, options);

        this.container = document.querySelector(container);
        this.venueSelect = this.container.querySelectorAll(this.options.venueSelect);
        this.contactBlocks = this.container.querySelectorAll(this.options.contactBlock);

        this.setEvents();
    }

    setEvents() {
        var self = this;
        this.venueSelect.forEach(venue => {
            venue.addEventListener('click', function() {self.onVenueSelect(this);});
        });
    }

    onVenueSelect(elem) {
        var id = elem.dataset.id;

        this.filterContacts(id);
    }
    
    filterContacts(id) {
        this.contactBlocks.forEach(block => {
            block.classList.add('inactive')

            if (block.dataset.venue === id) {
                block.classList.remove('inactive')
            }
        })
    }
}